import React, { Component } from 'react';
import {login, setLoadingLogin, loginSuccessful, loginError} from '../../actions/AuthActions';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {path_reset_password, path_registration} from '../../routes/Pathnames';
import {TRANSLATE_LOGIN_FORGOT_PASSWORD, TRANSLATE_SIGN_UP, TRANSLATE_SIGN_IN} from '../../translates/Translates';
import {Link} from 'react-router-dom';

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                email: '',
                password: ''
            },
        }

        this.login = this.login.bind(this);
    }

    login = (data) => { 
        this.props.setLoadingLogin();
        this.props.login(data).then(() => {
            this.props.loginSuccessful();
        }).catch(() => {
            this.props.loginError();
        })
    }

    handleChange = (event) => {
        let field = event.target.name;
        let value = event.target.value;
        this.setState(prevState => {
            let form = prevState.form;
            form[field] = value;
            return {
                ...prevState,
                form
            }
        })
    }

    render() {
            return (
            <section id="wrapper">
                <div className="login-register">
                    <div className="login-box card">
                        <div className="card-body">
                            <form className="form-horizontal form-material" id="loginform" method="post">
                                <h3 className="p-2 rounded-title mb-3">{TRANSLATE_SIGN_IN}</h3>
                                <div className="form-group ">
                                    <div className="col-xs-12">
                                        <input className="form-control" type="text" name="email" placeholder="E-mail" onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="col-xs-12">
                                        <input className="form-control" type="password" name="password" placeholder="Password" onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="form-group text-center mt-3">
                                    <div className="col-xs-12">
                                        <button
                                            className="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                                            type="button" onClick={() => this.login(this.state.form)}>{TRANSLATE_SIGN_IN}</button>
                                    </div>
                                </div>
                                <div className="form-group mb-0">
                                    <div className="col-sm-12 text-center">
                                        <div className="mb-2">
                                            <Link to={path_registration}
                                                className="text-info ml-1"><b>{TRANSLATE_SIGN_UP}</b></Link>
                                        </div>
                                        <Link to={path_reset_password}
                                            className="text-info"><b>{TRANSLATE_LOGIN_FORGOT_PASSWORD}</b></Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        login,
        setLoadingLogin,
        loginSuccessful,
        loginError
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(Login);
